import { ChangeDetectionStrategy, Component, HostListener, OnInit, inject } from '@angular/core';

import { DeviceService, WINDOW } from '@frontend/vanilla/core';
import { LetDirective } from '@ngrx/component';
import { Store } from '@ngrx/store';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseDetailsTermsConditionsComponent } from '../../../base-details/base-details-terms-conditions/base-details-terms-conditions.component';
import { BaseDetailsContent } from '../../../base-details/base-details.model';
import { CalculateResultComponent } from '../../common/common-results/calculate-result/calculate-result.component';
import { CrossSellingComponent } from '../../common/common-results/cross-selling/cross-selling.component';
import { ResultsInfoGroupComponent } from '../../common/common-results/results-info-group/results-info-group.component';
import { ResultsPrizeGroupComponent } from '../../common/common-results/results-prize-group/results-prize-group.component';
import { PromotionStatuses } from '../../common/models/PromotionStatus/promotion-statuses';
import { ResultsContent } from '../../common/models/results/results-content';
import {
    TargetPromoState,
    commonContentMessages,
    resultsContent,
    resultsInfos,
    resultsPrizesLength,
    targetPromoContent,
} from '../../common/store/target-promotion.selectors';
import { showCheckButton } from '../store/player-activity.selectors';

interface PlayerActivityResultsViewModel {
    resultsPrizesLength: number;
    baseDetailsContent: BaseDetailsContent;
    commonContentMessages: { [key: string]: string };
    showCheckButton: boolean;
    resultsContent: ResultsContent;
}

@Component({
    selector: 'tp-player-activity-results',
    templateUrl: './player-activity-results.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        LetDirective,
        CalculateResultComponent,
        ResultsPrizeGroupComponent,
        ResultsInfoGroupComponent,
        CrossSellingComponent,
        BaseDetailsTermsConditionsComponent,
    ],
})
export class PlayerActivityResultsComponent implements OnInit {
    desktop: boolean = true;
    promotionStatuses = PromotionStatuses;

    resultsContent$ = this.store.select(resultsContent);
    resultsInfos$ = this.store.select(resultsInfos);

    vm$: Observable<PlayerActivityResultsViewModel> = combineLatest([
        this.store.select(targetPromoContent),
        this.store.select(resultsPrizesLength),
        this.store.select(commonContentMessages),
        this.store.select(showCheckButton),
        this.resultsContent$,
    ]).pipe(
        map(([targetPromoContent, resultsPrizesLength, commonContentMessages, showCheckButton, resultsContent]) => {
            return {
                resultsPrizesLength,
                baseDetailsContent: targetPromoContent,
                commonContentMessages: commonContentMessages ?? {},
                showCheckButton,
                resultsContent,
            };
        }),
    );
    readonly #window = inject(WINDOW);

    constructor(
        private deviceService: DeviceService,
        private store: Store<{ targetPromotionModuleData: TargetPromoState }>,
    ) {}

    ngOnInit() {
        this.desktop = !this.deviceService.isMobile;
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.desktop = this.#window.innerWidth > 600;
    }
}
